import { pick } from "lodash";

export interface ExtendedContext {
  // TODO, should replace string with hasura table name
  // To have type checking and completion in the app
  additionalTypenames?: string[];
}

const customContextKeys: (keyof ExtendedContext)[] = ["additionalTypenames"];

export const getRequestContext = (request: any): ExtendedContext => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
  return pick(request?.context || {}, customContextKeys);
};
